var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLostLeftover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.3125H13.4375V11.5C13.4375 11.168 13.1445 10.875 12.8125 10.875H12.1875C11.8359 10.875 11.5625 11.168 11.5625 11.5V14.3125H8.75C8.39844 14.3125 8.125 14.6055 8.125 14.9375V15.5625C8.125 15.9141 8.39844 16.1875 8.75 16.1875H11.5625V19C11.5625 19.3516 11.8359 19.625 12.1875 19.625H12.8125C13.1445 19.625 13.4375 19.3516 13.4375 19V16.1875H16.25C16.582 16.1875 16.875 15.9141 16.875 15.5625V14.9375C16.875 14.6055 16.582 14.3125 16.25 14.3125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 24.3125H24.75C24.3984 24.3125 24.125 24.6055 24.125 24.9375V25.5625C24.125 25.9141 24.3984 26.1875 24.75 26.1875H32.25C32.582 26.1875 32.875 25.9141 32.875 25.5625V24.9375C32.875 24.6055 32.582 24.3125 32.25 24.3125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0742 30.4648H15.2109L22.3359 11.9375H24.1875L17.0742 30.4648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostLeftover);
export default __webpack_public_path__ + "static/media/lost-leftover.c0a737754f8c31294c5fda56deca35a5.svg";
export { ForwardRef as ReactComponent };